import React from 'react';
import { ResortPhotosData } from '@/components/widget/types';
import { ImageComponent } from '@/components/common/ImageComponent';
import { ItemsContainer } from '@/components/common/ItemsContainer';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { SectionHeader } from '../SectionHeader';

interface Props {
  photos: ResortPhotosData;
  resortDescription?: { dangerouslySetInnerHTML: { __html: string; }; };
  title?: string;
  isSummerMode?: boolean;
}

// Resort overview hero gallery. Single-photo-per-view scroll-snap
// rail — swipe on mobile, photo-carousel-style left/right chevron
// overlays on desktop. SectionHeader below.

export const OverviewTopSlider = ({
  photos, resortDescription, title, isSummerMode = false,
}: Props) => {
  const { t } = useOTSTranslation('common');
  if (!photos?.length) {
    return (
      <section>
        <SectionHeader title={title} description={resortDescription} isSummerMode={isSummerMode} />
      </section>
    );
  }

  return (
    <section>
      <ItemsContainer
        ariaLabel={title ?? t('resort.overview.resortPhotos')}
        navStyle="overlay"
        className="mb-7 [&_img]:max-h-[700px] [&_img]:rounded-[20px] [&_img]:!h-full [&_img]:object-cover"
      >
        {photos.map((item) => (
          <ItemsContainer.Item
            key={item.cdnUrl}
            className="!basis-full sm:!basis-full lg:!basis-full"
          >
            <ImageComponent alt={item.name} src={item.cdnUrl} />
          </ItemsContainer.Item>
        ))}
      </ItemsContainer>
      <SectionHeader title={title} description={resortDescription} isSummerMode={isSummerMode} />
    </section>
  );
};
